
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/favorites",
      function () {
        return require("private-next-pages/favorites.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/favorites"])
      });
    }
  